import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
} from '@mui/material';
import {
  dialogPaperSx,
  dialogTitleSx,
  dialogSecondaryBtnSx,
} from '../../theme/themedSx';

function idEq(a, b) {
  return a != null && b != null && (a === b || String(a) === String(b));
}

/**
 * Active / De-active DBA (active_status) — used on Complete (approved) list only.
 */
export default function DbaActiveStatusDialog({
  open,
  onClose,
  onConfirm,
  selectedDba,
  value,
  onChange,
  processingId,
}) {
  const busy = processingId && selectedDba && idEq(processingId, selectedDba.id);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth sx={dialogPaperSx}>
      <DialogTitle sx={dialogTitleSx}>Change DBA Status Value</DialogTitle>
      <DialogContent sx={{ pt: 3, pb: 2 }}>
        <DialogContentText sx={{ mb: 2, color: 'grey.700' }}>
          Update the active status for {selectedDba?.name || 'this DBA'}. Select Active (1) or
          De-active (0) below.
        </DialogContentText>
        <FormControl fullWidth variant="outlined">
          <InputLabel>Change DBA Status Value</InputLabel>
          <Select
            value={value}
            onChange={(e) => onChange(e.target.value)}
            label="Change DBA Status Value"
            sx={{ bgcolor: 'background.paper', borderRadius: 1 }}
          >
            <MenuItem value="1">Active</MenuItem>
            <MenuItem value="0">De-active</MenuItem>
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <Button onClick={onClose} variant="outlined" color="inherit" sx={dialogSecondaryBtnSx}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="primary"
          disabled={value === '' || busy}
          startIcon={busy ? <CircularProgress size={20} color="inherit" /> : null}
        >
          Update Status Value
        </Button>
      </DialogActions>
    </Dialog>
  );
}
